export default {
  guide:
    'こちらの数値はCPに幾つの広告を作れることに影響します \n\n 例えば、CPの１日予算を500円に設定して \n FBの値は131円に設定して \n ユーザーさんがFBの広告を作成するときに \n 最大広告数は３になります (500 / 131 ≈ 3)'
};
